<template>
	<div class="login-background">
		<div class="login-container">
			<div class="login-header">系统登录</div>
			<div class="login-card">
				<el-form ref="form" :model="userInfo" label-width="80px" style="width:350px">
          <el-row style="margin-bottom: 20px">
            <el-col :span="24">
              <el-input v-model="userInfo.loginName" placeholder="请输入用户名" @keydown.enter.native="onSubmit"></el-input>
            </el-col>
          </el-row>
          <!-- <el-row style="margin-bottom: 20px" >
            <el-col :span="18">
              <el-input v-model="userInfo.code" placeholder="验证码" @keydown.enter.native="onSubmit"></el-input>
            </el-col>
            <el-col :span="6">
            	<el-button @click="sendCode" :disabled="btnActive" :type="btnType">{{codeText}}</el-button>
            </el-col>
          </el-row> -->
          <el-row style="margin-bottom: 20px" >
            <el-col :span="24">
              <el-input v-model="userInfo.password" placeholder="请输入密码" show-password @keydown.enter.native="onSubmit"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
            	<el-button type="primary" style="width: 200px" @click="onSubmit" >登录</el-button>
            </el-col>
          </el-row>
        </el-form>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  data() {
    return {
      loading: null,
      userInfo: {
				loginName: '',
				password: '',
				//code: '',
		  },
		  codeText: '获取验证码',
		  btnActive: false,
		  btnType: 'text'
    }
  },
  methods:{
	async getUserInfo(){
		let userInfo = await this.$equipmentdata.getUserInfo();
		return userInfo;
	},

	async onSubmit() {
      this.loading = this.$loading({
        lock: true,
        text: '拼命加载中...',
      });
      try{
        let result = await this.$request.login(this.userInfo.loginName,this.userInfo.password);
        if(result.code == 0){
        	this.$message('登录成功');
          localStorage.setItem('token',result.data.token);
          await this.$router.push('/Instrument/Product');
        }else{
        	this.$message(result.errMsg);
        }
      } catch(e) {
        this.$message(e);
      } finally {
				this.loading.close();
      }
    },

	  // async sendCode(){
	  // 	console.log('发送短信验证码');
	  // 	this.btnActive = true;
	  // 	this.btnType = 'info'
	  // 	this.codeText = 59;
	  // 	const timer = setInterval(() => {
	  // 		this.codeText = Number(this.codeText) - 1;
	  // 		if(Number(this.codeText) === 0){
	  // 			clearInterval(timer);
	  // 			this.btnActive = false;
	  // 			this.codeText = '获取验证码';
	  // 			this.btnType = 'text';
	  // 		}
	  // 	},1024)
	  // 	let result = await this.$equipmentdata.sendCode(this.userInfo.loginName);
	  // 	if(result === '请输入账号' || result === '该用户未设置手机号码'){
	  // 		clearInterval(timer);
  	// 		this.btnActive = false;
  	// 		this.codeText = '获取验证码';
  	// 		this.btnType = 'text';
	  // 	}
	  // 	this.$message(result);
	  // }

  },

}
</script>

<style type="text/css">
html,body{
  margin: 0;
  height: 100%;
}
.login-background{
	height: 100%;
	width: 100%;
	background: linear-gradient(to top, #209CFF, #68E0CF);
	display: flex;
	justify-content: center;
	align-items: center;
}
.login-container{
	text-align: center
}
.login-header{
	color: #FCFCFC;
	font-size: 30px;
	font-weight: 700;
}
.login-card{
	margin-top: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 450px;
	height: 260px;
	background-color: #FCFCFC;
	border-radius: 3%;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue